import { render, staticRenderFns } from "./ActiveBacklog-Column-City.vue?vue&type=template&id=421b52dc&"
import script from "./ActiveBacklog-Column-City.vue?vue&type=script&lang=js&"
export * from "./ActiveBacklog-Column-City.vue?vue&type=script&lang=js&"
import style0 from "./ActiveBacklog-Column-City.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports